export const common = {
  nav: {
    brandStory: '品牌故事',
    technology: '核心技术',
    products: '产品系列',
    sustainability: '可持续承诺',
    cta: '探索实验室',
  },
  brand: {
    name: '膳兜兜',
    nameEn: 'Foodgogo',
  },
  footer: {
    brandStory: '品牌故事',
    brandOrigin: '品牌起源',
    rdTeam: '研发团队',
    brandVision: '品牌愿景',
    coreTechnology: '核心技术',
    freezeDry: '冻干锁鲜',
    microEncapsulation: '微胶囊包埋',
    coldExtraction: '低温萃取',
    productSeries: '产品系列',
    functionalGummies: '功能性软糖',
    freezeDriedTonics: '冻干滋补品',
    herbalEnergyBars: '中式能量棒',
    sustainability: '可持续承诺',
    cleanLabel: '清洁标签',
    greenSupplyChain: '绿色供应链',
    circularPackaging: '循环包装',
    contact: 'info@mizean.com',
    copyright: ' 2026 膳兜兜 foodgogo. 保留所有权利。',
  },
  langSwitch: {
    zh: '中文',
    en: 'EN',
  },
  notFound: {
    title: '页面未找到',
    subtitle: 'This page has not been generated',
    hint: 'Tell me more about this page, so I can generate it',
  },
  misc: {
    scroll: 'SCROLL',
    viewAll: '查看全部产品',
    learnMore: '了解更多',
    viewDetails: '查看详情',
    step: 'Step',
    coreIngredients: '核心成分',
    suitableFor: '适合：',
  },
};